// Configurable Intersection Observer helper
const createInViewObserver = ({
  root = null,
  rootMargin = "0px 0px -50px 0px", // Trigger 50px after entering
  once = true,
  className = "in-view",
} = {}) => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add(className);

          if (once) observer.unobserve(entry.target);
        }
      });
    },
    {
      root,
      rootMargin,
      threshold: 0,
    },
  );

  return observer;
};

const Intersections = {
  observer: null,

  init({
    selector = ".fade-in, .service-fades, .news-fades, .testimonial-fades, .service-step-fades, .secondary-banner--shapes",
    rootMargin = "0px 0px -50px 0px",
    once = true,
    className = "in-view",
  } = {}) {
    this.observer = createInViewObserver({
      rootMargin,
      once,
      className,
    });

    document.querySelectorAll(selector).forEach((el) => {
      this.observer.observe(el);
    });
  },

  destroy() {
    this.observer?.disconnect();
  },
};

export default Intersections;
